<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-100" style="background: rgb(81,112,255);
                  background: linear-gradient(135deg, rgba(81,112,255,1) 0%, rgba(203,12,159,1) 100%);">
        <div class="container">
          <div class="row" style="justify-content: center;">

            <div id="logoTomate" class="col-6" style="display: flex;
              justify-content: center;">
              <img src="../assets/img/ToMate.png" class="navbar-brand-img h-100" alt="main_logo" style="
              display: block;
              width: auto;"/>
            </div>

            <div class="mx-auto col-xl-6 col-lg-6 col-md-6 d-flex flex-column">

              <div class="container" style="width: fit-content;">
                <div class="card z-index-0">
                  <!--<img src="../assets/img/logo-ToMate.png" class="navbar-brand-img h-100" alt="main_logo" style="opacity: 0.8; margin: -140px 0;"/>-->
                  <div class="pb-0 card-header text-start">
                    <h3 class="font-weight-bolder text-success">
                      Reset password
                    </h3>
                    <p class="mb-0">Enter an email account to send the reset link</p>
                  </div>
                  <div class="card-body">
                      <div class="mb-3">
                        <input
                          id="email"
                          type="email"
                          class="form-control"
                          name="email"
                          v-model="email"
                          placeholder="Enter your email"
                          isRequired="required"
                        />
                      </div>
                      
                      <div class="text-center">
                        <soft-button
                          @click="resetPassword()"
                          class="my-4 mb-2"
                          color="success"
                          full-width
                          >Send link
                        </soft-button>
                      </div>
                      <p class="text-sm mt-3 mb-0">
                        <router-link
                          :to="{ name: 'Sign In' }"
                          class="text-dark font-weight-bolder"
                        >
                          Back to Log In page
                        </router-link>
                      </p>
                  </div>
                </div>
                <br>
                <soft-alert v-show="emailSent === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>Email sent</strong> Check your inbox!
                </soft-alert>
                <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>{{ responseMessage }}</strong>
                </soft-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer-entrada class="footer"/>
</template>

<script>
import AppFooterEntrada from "@/examples/PageLayout/FooterEntrada.vue";
import SoftButton from "@/components/SoftButton.vue";
import { mapMutations } from "vuex";
import HTFetch from "../llamadas/HTFetch"
import K from "../llamadas/K"
import SoftAlert from "@/components/SoftAlert.vue";
//import router from '../router/index'

export default {
  name: "ResetPass",
  components: {
    AppFooterEntrada,
    SoftButton,
    SoftAlert
  },

  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },

  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },

  data() {
    return {
      llamada: new HTFetch(),
      K: new K(),
      wrongCreds: false,
      email: "",
      emailSent: false,
      responseMessage: "",
      showResponseMessage: false
    }
  },

  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    resetPassword() {
      
      let body = {
        "email": this.email,
      }

      this.llamada.sendResetPass(body, this.resetPasswordRsp.bind(this))
    },

    resetPasswordRsp(rsp) {
      if (399 < rsp.status && rsp.status < 501) {
        if ('detail' in rsp.data) {
          this.responseMessage = rsp.data.detail.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('Message' in rsp.data) {
          this.responseMessage = rsp.data.Message.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('message' in rsp.data) {
          this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('Error' in rsp.data) {
          this.responseMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
        }
        
        this.showResponseMessage = true

        setTimeout(() => {
          this.showResponseMessage = false
        }, 5000)

        return
      }

      if (rsp.status === 200 || rsp.status === 201) {
        this.emailSent = true

        setTimeout(() => {
          this.emailSent = false
        }, 2000)
        
      }

      //router.push({ name: 'Sign In' })
    }
  },
};
</script>
<style scoped>
  #logoTomate {
      height: 300px;
    }
  @media (max-width: 1000px) {
    #logoTomate {
      height: 250px;
    }
  }
  @media (min-width: 1000px) {
    #logoTomate {
      height: 300px;
    }
  }
  @media (max-width: 400px) {
    #logoTomate {
      height: 215px;
    }
  }

  @media (max-height: 600px) {
    .footer {
      display: none;
    }
  }

  @media (max-width: 770px) {
    .footer {
      display: none;
    }
  }
</style>
